import { gql } from '@apollo/client'

import {
  CHAT_DETAILS_OFFER_FRAGMENT,
  OFFER_FRAGMENT,
  POST_WITH_RATES_FRAGMENT,
  PUBLIC_POST_FRAGMENT
} from '../fragments'

export const POST_OFFER = gql`
  query PostOffer($offerID: ID!, $postID: ID!) {
    postOffer(input: { offerID: $offerID, postID: $postID }) {
      ...ChatDetailsOfferFragment
    }
  }
  ${CHAT_DETAILS_OFFER_FRAGMENT}
`

export const POST_OFFERS = gql`
  query PostOffers($id: ID!) {
    postOffers(input: { id: $id }) {
      ...OfferFragment
    }
  }
  ${OFFER_FRAGMENT}
`

export const GET_POST_BY_ID = gql`
  query GetPostByID($id: ID!) {
    getPostByID(input: { id: $id }) {
      ...PostFields
      created
    }
  }
  ${PUBLIC_POST_FRAGMENT}
`

export const POST_WITH_RATES = gql`
  query GetPostByID($id: ID!) {
    getPostByID(input: { id: $id }) {
      ...PostWithRatesFragment
      offers {
        ...ChatDetailsOfferFragment
      }
      created
    }
  }
  ${POST_WITH_RATES_FRAGMENT}
  ${CHAT_DETAILS_OFFER_FRAGMENT}
`

export const MY_OFFERS = gql`
  query MyOffers($input: MyOffersInput) {
    myOffers(input: $input) {
      offers {
        id
        mcNumber
        emptyAtPreviousReceiverTime
        location
        offerStatus
        amount {
          value
          currency
        }
        message
        post {
          ...PostFields
        }
        user {
          id
        }
        created
      }
      paginationKey
    }
  }
  ${PUBLIC_POST_FRAGMENT}
`

/**
 * Get workspace offers emails
 */
export const GET_WORKSPACE_OFFERS_EMAILS = gql`
  query {
    workspaceOffersEmails {
      email
    }
  }
`

/**
 * Get workspace oauth configurations
 */
export const GET_WORKSPACE_OAUTH_CONFIGURATIONS = gql`
  query {
    emailConfigurations {
      email
      emailProvider
      displayEmailAddress
      name
    }
  }
`
